import { isSectionCompleted } from "./builder/rentalBuilderConfig";

const RentalBuilderNav = ({
  items,
  activeSectionId,
  savedStage,
  hasRentalId,
  hasTerms,
  isEditingExisting = false,
  onSectionClick,
  orientation = "vertical",
}) => {
  const isVertical = orientation === "vertical";

  const isLocked = (item) => {
    if (isEditingExisting) return false;
    if (!hasRentalId && item.id !== "general") return true;
    return item.stage > savedStage;
  };

  if (!isVertical) {
    return (
      <div className="flex gap-1 overflow-x-auto pb-1 scrollbar-hide">
        {items.map((item) => {
          const isActive = activeSectionId === item.id;
          const isCompleted = isSectionCompleted(savedStage, item.stage, hasTerms);
          const locked = isLocked(item);

          return (
            <button
              key={item.id}
              type="button"
              onClick={() => onSectionClick(item.id, item.stage)}
              className={`shrink-0 rounded-full px-3 py-1.5 text-xs font-medium transition ${
                isActive
                  ? "bg-primary text-white shadow-sm"
                  : locked
                  ? "bg-gray-50 text-gray-400 ring-1 ring-gray-200"
                  : "bg-white text-gray-600 ring-1 ring-gray-200 hover:bg-gray-50"
              }`}
            >
              {isCompleted && !isActive ? "✓ " : ""}
              {item.shortName}
              {locked ? " ·" : ""}
            </button>
          );
        })}
      </div>
    );
  }

  return (
    <nav className="space-y-0.5">
      {items.map((item) => {
        const isActive = activeSectionId === item.id;
        const isCompleted = isSectionCompleted(savedStage, item.stage, hasTerms);
        const locked = isLocked(item);

        return (
          <button
            key={item.id}
            type="button"
            onClick={() => onSectionClick(item.id, item.stage)}
            className={`flex w-full items-center gap-3 rounded-lg px-3 py-2.5 text-left transition-all duration-200 ${
              isActive
                ? "bg-primary/10 text-primary shadow-sm ring-1 ring-primary/20"
                : locked
                ? "text-gray-400"
                : "text-gray-600 hover:bg-gray-50"
            }`}
          >
            <span
              className={`flex h-6 w-6 shrink-0 items-center justify-center rounded-full text-[11px] font-bold transition ${
                isActive
                  ? "bg-primary text-white"
                  : isCompleted
                  ? "border border-emerald-100 bg-emerald-50 text-emerald-600"
                  : "bg-slate-100 text-slate-500"
              }`}
            >
              {isCompleted ? (
                <i className="fi fi-rr-check text-[10px]"></i>
              ) : (
                item.stage
              )}
            </span>
            <span className="min-w-0 flex-1">
              <span className="block text-sm font-medium leading-tight">{item.shortName}</span>
              {!isActive && (
                <span className="mt-0.5 block text-[11px] leading-snug text-gray-400">
                  {locked ? "Locked" : isCompleted ? "Complete" : "Pending"}
                </span>
              )}
            </span>
            {locked && <i className="fi fi-rr-lock text-xs text-gray-400"></i>}
          </button>
        );
      })}
    </nav>
  );
};

export default RentalBuilderNav;
